export var ENGINE_URL = 'http://cocktail/kit'
if (process.env.NODE_ENV === 'production') ENGINE_URL = '/kit';